import { createFileRoute } from "@tanstack/react-router";
import CreateOrganization from "@/features-root-user/organization/create-organization";

export const Route = createFileRoute(
  "/_root/root-user/organization/create-organization",
)({
  component: CreateOrganization,
});
